import { useState } from 'react';
import ICMemberList from '../../components/admin/ic-members/ICMemberList';
import ICMemberForm from '../../components/admin/ic-members/ICMemberForm';
import Button from '../../components/shared/UI/Button';

export default function ICMembersPage() {
  const [view, setView] = useState('list');
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedFundId, setSelectedFundId] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedMember(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>IC Member Configuration</h1>
          <p>Assign IC members to funds. Users must have role "IC Member" to appear here.</p>
        </div>
      </div>

      {view === 'list' && (
        <ICMemberList
          key={refreshKey}
          onAdd={(fundId) => { setSelectedFundId(fundId); setSelectedMember(null); setView('add'); }}
          onEdit={(member, fundId) => { setSelectedMember(member); setSelectedFundId(fundId); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedMember(null); }}>
              ← Back to IC Members
            </Button>
          </div>
          <div className="card">
            <div className="card-header">
              <h2>{view === 'add' ? 'Add IC Member' : `Edit: ${selectedMember?.full_name}`}</h2>
            </div>
            <div className="card-body">
              <ICMemberForm
                member={view === 'edit' ? selectedMember : null}
                fundId={selectedFundId}
                onSaved={handleSaved}
                onCancel={() => { setView('list'); setSelectedMember(null); }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
